import { useEffect } from "react";

// STYLES
import * as Style from "./LockerListStyle";

// LIBRARIES
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// MISC
import { ButtonTypes, ModalTypes } from "models/GeneralTypes/generalTypes";

// ASSETS

// REDUX
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { getAllLockers } from "api/lockerApi";
import { lockersList } from "slices/lockerSlice";

// COMPONENTS
import LockerItem from "components/LockerItem/LockerItem";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import { toggleModalState } from "slices/uiSlice";

const LockerList = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const lockerListData = useAppSelector(lockersList);

  // CONSTANTS USING HOOKS
  const navigate = useNavigate();
  const { t } = useTranslation();

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    dispatch(getAllLockers());
    // eslint-disable-next-line
  }, []);

  // Helper function to check if user is "mondo"
  const isMondoUser = () => {
    const username = localStorage.getItem('username');
    return username === 'mondo';
  };

  // Filter lockers for mondo user
  const getFilteredLockers = () => {
    if (isMondoUser() && lockerListData) {
      return lockerListData.filter(locker => locker.id === 56);
    }
    return lockerListData;
  };

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleNavigate = () => {
    dispatch(
      toggleModalState({
        isVisible: true,
        type: ModalTypes.ADD_NEW_LOCKER,
      })
    );
  };

  return (
    <Style.Container>

      <Style.Containers>
        {getFilteredLockers()?.map((lockerDetails) => (
          <LockerItem
            key={lockerDetails.id}
            onClick={() => navigate(`lockerDetails/${lockerDetails.id}`)}
            lockerDetails={lockerDetails}
          />
        ))}
      </Style.Containers>
    </Style.Container>
  );
};

export default LockerList;
